/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Linear_Th8Inputs */

const en_mk_cmp_linear_th8 = /** @type {(inputs: Mk_Cmp_Linear_Th8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broad: GitHub, Slack, Figma, Sentry and dozens more.`)
};

const id_mk_cmp_linear_th8 = /** @type {(inputs: Mk_Cmp_Linear_Th8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luas: GitHub, Slack, Figma, Sentry, dan puluhan lainnya.`)
};

/**
* | output |
* | --- |
* | "Broad: GitHub, Slack, Figma, Sentry and dozens more." |
*
* @param {Mk_Cmp_Linear_Th8Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_linear_th8 = /** @type {((inputs?: Mk_Cmp_Linear_Th8Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Linear_Th8Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_linear_th8(inputs)
	return en_mk_cmp_linear_th8(inputs)
});